import { Alert, Grid, Stack } from '@mui/material'
import { useState } from 'react'
import { FiltrosBusqueda, FormFiltros, FormFiltrosFields, schemaFiltrosBusqueda } from 'src/pages/limites/FiltrosBusqueda'
import { QueryStatus } from 'src/types'
import { SistemaTipo } from 'src/types/enum/enum'
import { useLimitesLCLS } from '../../sistema/sistemas/lcls/hooks/useLimites'
import { OperacionLCLSLimitesAprobadosPaisFields } from '../../sistema/sistemas/lcls/types/fields'
import LimiteLCLS from './LimiteLCLS'

const LCLS_FORM_FIELDS = [
    FormFiltrosFields.Pais,
    FormFiltrosFields.UnidadNegocio,
    FormFiltrosFields.NumeroCuenta,
    FormFiltrosFields.RazonSocial,
];

export function LimitesLCLS() {
    const [apiFiltros, setApiFiltros] = useState<FormFiltros>(
        schemaFiltrosBusqueda.parse({})
    )

    const { limites, status } = useLimitesLCLS(apiFiltros)

    const handleFilterChange = (nuevosFiltros: FormFiltros) => {
        setApiFiltros(nuevosFiltros)
    }

    return (
        <Grid container gap={10}>
            <Grid item xs={12} sx={{ mb: -5 }}>
                <FiltrosBusqueda
                    formFields={LCLS_FORM_FIELDS}
                    mensajeTipo={SistemaTipo.LCLS}
                    onFilterChange={handleFilterChange}
                />
            </Grid>

            <Stack spacing={5} width={'100%'}>
                {limites?.map(l => (
                    <LimiteLCLS key={l[OperacionLCLSLimitesAprobadosPaisFields.CodPais]} data={l} />
                ))}
                {(!limites?.length && status === QueryStatus.Success) && <Alert severity="warning">No se encontraron datos.</Alert>}
            </Stack>
        </Grid>
    )
}
